import { useQuery } from '@tanstack/vue-query';
import { computed, unref } from '@vue/composition-api';
import type { MaybeRef } from '@vueuse/core';
import { DashboardService } from '../../../api/service/dashboard.service';
import { widgetKeys } from '../../../api/widget-keys';

export const useActiveDealTimes = (
  interval: { from: number; to: number },
  showAll: MaybeRef<boolean>
) =>
  useQuery({
    queryKey: computed(() => widgetKeys.activeDealTimesDetail(interval, unref(showAll))),
    queryFn: () => DashboardService.loadDocumentDealTimes(interval, unref(showAll)),
  });
